/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export default function createFormValueGetter(userFormValues: Record<string, { value: string | boolean } | undefined>) {
  return (fieldName: string) => {
    const value = userFormValues[fieldName]?.value;
    if (typeof value === 'boolean') {
      return value;
    } else {
      return value?.trim() || '';
    }
  };
}
